import { css } from "lit";

export default css`
    .game {
        height: 100%;
        display: grid;
        grid-template-columns: 1fr;
        grid-template-rows: auto auto 1fr auto;
        grid-column-gap: 0;
        grid-row-gap: 0;
    }

    .number {
        text-align: center;
        font-size: 50px;
        margin-top: 10px;
    }

    .header {
        display: flex;
        flex-direction: column;
        align-items: center;
        flex-grow: 1;
        position: relative;
        margin-top: 10px;
        margin-bottom: 10px;
    }

    .header img {
        height: auto;
        image-rendering: pixelated;
        max-height: 50vh;
        max-width: 55rem;
        width: 100%;
        object-fit: cover;
    }

    .header img:nth-child(n + 2) {
        max-height: none;
        position: absolute;
    }

    .content {
        flex-grow: 1;
        overflow: auto;
        margin-top: auto;
        padding: 0 10px;
        z-index: 15;
        text-shadow: 2px 2px 10px #000000;
        max-height: 100%;
    }

    .content-text {
        overflow: auto;
        white-space: pre-wrap;
    }

    .content p {
        overflow-x: hidden;
        margin: 0 0 10px 0;
    }

    .content p:last-of-type {
        margin: 0;
    }

    .footer {
        border-radius: 10px 10px 0 0;
        background-color: #212121;
        border: 1px solid #212121;
        margin-top: 10px;
        display: flex;
        height: 105px;
        z-index: 10;
    }

    .footer .buttons {
        display: flex;
        flex-direction: column;
        overflow: auto;
        padding: 10px 10px 0 10px;
    }

    .footer .button {
        background-color: #000000;
        border: 1px solid #000000;
        padding: 5px 10px;
        margin: 0 0 10px 10px;
        text-transform: uppercase;
        cursor: pointer;
        display: inline-block;
        user-select: none;
    }

    .footer .button.active,
    .footer .button:hover {
        background-color: #3f3f3f;
        border: 1px solid #3f3f3f
    }

    .number-feedback {
        padding: 10px;
        margin-top: 20px;
        display: flex;
        justify-content: center;
        align-items: center;
        flex-wrap: wrap;
    }

    .correct-feedback {
        border: 4px solid green !important;
    }

    .incorrect-feedback {
        border: 4px solid orange !important;
    }

    .wrong-feedback {
        border: 4px solid red !important;
    }

    .number-feedback input {
        margin: 0 5px;
        text-align: center;
        height: 40px;
        width: 40px;
        font-size: 1.2em;
        padding: .5rem;
        background-color: transparent;
        color: lightgrey;
        border: 4px solid lightgrey;
        border-radius: 1rem;
    }

    .number-feedback button {
        margin-left: 10px;
        padding: 10px 20px;
        font-size: 1em;
        cursor: pointer;
        background-color: #007bff;
        border: none;
        border-radius: 5px;
    }

    .number-feedback .feedback {
        margin-top: 20px;
        display: flex;
        justify-content: center;
        width: 100%;
    }

    .number-feedback .feedback div {
        display: inline-block;
        width: 40px;
        height: 40px;
        line-height: 40px;
        text-align: center;
        margin: 0 5px;
        border-radius: 50%;
        font-weight: bold;
    }

    .number-feedback input::-webkit-inner-spin-button,
    .number-feedback input::-webkit-outer-spin-button {
        -webkit-appearance: none;
        margin: 0;
    }

    /* For Firefox */

    .number-feedback input[type=number] {
        -moz-appearance: textfield;
    }
`;